import { render, staticRenderFns } from "./ListaComprobantes.vue?vue&type=template&id=0792af2d"
import script from "./ListaComprobantes.vue?vue&type=script&lang=js"
export * from "./ListaComprobantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports